import React, {FC} from 'react'

import cn from 'classnames/bind'

import LandingsAccordion from 'components/blocks/LandingsAccordion'
import LandingsTitle from 'components/blocks/LandingsTitle'
import {Container, Row, Col} from 'components/elements/grid'
import {IMake1099Content} from 'pages/make-your-1099'

import s from './Make1099Faq.module.scss'
const cx = cn.bind(s)

interface IMake1099FaqProps {
	className?: string
	content: IMake1099Content['faq']
}

/** Make1099Faq block component */
const Make1099Faq: FC<IMake1099FaqProps> = ({className, content}) => {
	return (
		<div className={cx('wrapper', className)}>
			<Container>
				<LandingsTitle className={s.title} title={content?.title} />
				<Row>
					<Col>
						<LandingsAccordion items={content?.items} />
					</Col>
				</Row>
			</Container>
		</div>
	)
}

Make1099Faq.displayName = 'Make1099Faq'

export default Make1099Faq
